export default __webpack_public_path__ + "static/freight-big-pro-black-22084f49ef57286ae9189eee1a24d35b.woff2";